import { ButtonVariant } from '@/components/shared/GrainButton'
import primaryOnDarkLoadingAnimation from '../public/static/primaryOnDarkLoadingAnimation.json'
import primaryOnLightLoadingAnimation from '../public/static/primaryOnLightLoadingAnimation.json'
import secondaryColorLoadingAnimation from '../public/static/secondaryColorLoadingAnimation.json'
import whiteLoadingAnimation from '../public/static/whiteLoadingAnimation.json'

export const loadingAnimations = {
  primaryLight: primaryOnLightLoadingAnimation,
  primaryDark: primaryOnDarkLoadingAnimation,
  secondary: secondaryColorLoadingAnimation,
  white: whiteLoadingAnimation,
}

export const mapButtonTypeToAnimationColor = (buttonType: ButtonVariant, isDarkTheme = false) => {
  if (buttonType === 'secondary' || buttonType === 'tertiary') {
    return isDarkTheme ? 'primaryDark' : 'primaryLight'
  }

  if (buttonType === 'primary') {
    return 'white'
  }

  return ''
}
